import { useFormContext } from 'react-hook-form';

import InputForm from 'shared/components/Input/InputForm';
import { FieldTypesE } from 'shared/models/fields';
import { FragmentationFieldT } from 'shared/models/schc-templates';

interface FragmentationRenderFieldsProps {
  index: number;
  fields: Array<FragmentationFieldT>;
}
function FragmentationRenderFields({ index, fields }: FragmentationRenderFieldsProps) {
  const {
    register,
    getValues,
    control,
    formState: {
      errors,
    },
  } = useFormContext();
  return (
    <>
      {
        fields.map((field) => {
          if (field.type === FieldTypesE.CHECKBOX) {
            return (
              <InputForm.Checkbox
                key={field.name}
                label={field.displayName}
                name={`rules.${index}.fragmentation.${field.name}`}
                control={control}
                defaultChecked={getValues().rules[index].fragmentation[field.name] || false}
                disabled={field.disabled}
                helpText={field.helpText}
              />
            );
          }
          return (
            <InputForm.TextField
              key={field.name}
              fullWidth
              sx={{ mt: 1, mb: 1 }}
              type={field.type === FieldTypesE.NUMBER ? 'number' : 'string'}
              label={field.displayName}
              register={register(`rules.${index}.fragmentation.${field.name}`)}
              errorField={
                Array.isArray(errors.rules)
                  && errors.rules[index]
                  && errors.rules[index].fragmentation
                  && errors.rules[index].fragmentation[field.name]
              }
              defaultValue={field.defaultValue as string}
              disabled={field.disabled}
            />
          );
        })
      }
    </>
  );
}

export default FragmentationRenderFields;
